<template>
  <v-row  v-resize="onResize">
    <v-col cols=12 class="listCol py-0 px-2" >
      <v-container v-if="resourcesLoading" :height="listWindowHeight" class="drawerContainer pa-0 ma-0"  >
        <v-row  justify="center" align="center" class="drawerContainer" >
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
      </v-container>
      <div v-else-if="searchApplied && resources.lenght ===0"> No cameras match search criteria </div>
      <v-treeview v-else 
        id="tree"
        activatable
        multiple-active
        :active.sync="activeItems"
        active-class=""
        dense 
        :items="resources"
        :height="listWindowHeight" 
        class="dark list pt-0 pb-0 ml-n5" 
        v-on:update:active="update"
      >
        <template v-slot:label="{ item }" >
          <camera :id="item.id" :name="item.name"/>
        </template>
        
      </v-treeview>
    </v-col>
  </v-row>
</template>
<script>
import apiquery from '../../api/query'
export default {
  data(){
    return { 
      windowSize: {
        x: 0,
        y: 800
      },
      resourcesActive: [],
      callInterval: 0,
      pages: 0,
      resourcesFiltered: [],
      searchApplied: false
    }
  },
  components:{
    Camera: ()=> import('@/components/basics/Camera'),
  },
  async mounted(){
    try {
      this.resourcesLoading = true
      await apiquery.callDataAPI(this.pages).then((response)=>{
        if(response.lenght === 0)
          return null
        this.resources = Object.values(response)
        //this.callInterval = setTimeout(this.retrieveMoreCameras,500)
        this.resourcesLoading = false
        this.pages ++
      }).catch((e)=>{
        console.log(e)
        this.resourcesLoading = false
      })
    } catch (err) {
      //this.resourcesLoading = false
      console.log("retrieve err",err);
      console.log('secure api call failed');
    }
  },
  computed: {
    mobile: function(){
      return ((this.$vuetify.breakpoint.name=="xs")||(this.$vuetify.breakpoint.name=="sm"))
    },
    navDrawerHeight: function(){
      return this.$store.getters.getNavDrawerHeight
    },
    resources: {
      get(){
        return this.$store.getters.getResources
      },
      set(value){
        this.$store.commit('setResources', value)
      }
    },
    resource: {
      get(){
        return this.$store.getters.getResource
      },
      set(resource){
        return this.$store.commit('setResource',resource)
      }
    },
    searchquery: {
      get(){
        return this.$store.getters.getSearchQuery
      },
    },
    resourcesLoading: {
      get(){
        return this.$store.getters.getResourcesLoading
      },
      set(value){
        return this.$store.commit('setResourcesLoading', value)
      }
    },
    listWindowHeight: {
      get(){
        var height = 0
        var wheight = this.windowSize.y 
        if(this.mobile) {
          height = this.navDrawerHeight *.89
        }else
          height = this.navDrawerHeight
        var searchField_height_percentage = 78 / height
        var filler_height_percentage = 44 /height
        return wheight - wheight*(searchField_height_percentage+ filler_height_percentage)
      }
    },
    activeItems:{
      get(){
        return this.$store.getters.getActiveItems
      },
      set(value){
        this.$store.commit('setActiveItems', value)
      }
    },
    camerasInDisplay:{
      get(){
        return this.$store.getters.getCamerasInDisplay
      }
    }
    
  },
  methods:{ 
    async retrieveMoreCameras(){
      await apiquery.callDataAPI(this.pages).then((response)=>{
        if(response.length === 0){
          clearTimeout(this.callInterval)
          Object.freeze(this.resources)
          return null
        } 
        var aux = this.resources         
        aux.push(...response)
        this.resources= aux
        this.callInterval = setTimeout(this.retrieveMoreCameras, 500)
        this.pages ++
      })
    },
    update(){
      var element= ''
      var operation =''
      if(this.activeItems.length > this.$store.getters.getCamerasInDisplay){
        this.activeItems.shift()
      }
      if(this.activeItems.length ===0){
        if(this.resourcesActive.length > 0){
          element= this.resourcesActive[0]
          operation='remove'
        }else {
          return null          
        }
      } else {
        if((this.resourcesActive.length===0)||(this.resourcesActive.length === this.activeItems.length)){
          if(this.activeItems[this.activeItems.length-1] === this.resourcesActive[this.resourcesActive.length-1]){
            return null
          }
          element= this.activeItems[this.activeItems.length-1]
          operation='add'
        } else {
          if(this.activeItems.length < this.resourcesActive.length){
            element= this.resourcesActive.filter(item=> !this.activeItems.includes(item))[0]
            operation='remove'
          } else {
            element= this.activeItems.filter(item=> !this.resourcesActive.includes(item))[0]
            operation='add'
          }
        }
      }
      this.resourcesActive.splice(0, this.resourcesActive.length, ...this.activeItems)
      var aux= this.resources.find(resource=> resource.id === element)
      this.resource= {id: aux.id, name: aux.name, operation: operation} 
    },
    async applySearch(){
      this.searchApplied=true
      if(this.searchquery==='') {
        this.searchApplied=false
        return null
      }
      this.resourcesLoading = true
      await apiquery.retrieveSearch(this.searchquery).then((response)=>{
        this.resources = response
        this.resourcesLoading = false
      }).catch((e)=>{
        ('search failed: ', e)
        this.resourcesLoading = false
        this.searchApplied=false
      })
    },
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight}        
    },
    
  },
  watch: {
    async searchquery(newVal, oldVal) {
      if(newVal === oldVal){
        return null
      }
      if(newVal !== ''){
        this.applySearch()
      } else {
        this.pages= 0
        this.resources= []
        await this.retrieveMoreCameras()
      }
    },
    
    camerasInDisplay:function(newVal, oldVal){
      if(newVal===oldVal){
        return
      }
      if(this.activeItems && this.activeItems.length > newVal){
        this.activeItems.splice(newVal-1, this.activeItems.length-newVal)
      }
    }
  }
}
</script>

<style>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.list{
  overflow-y:auto;
  background: transparent !important
}

.listCol{
  max-height: 500px;
}
.drawerContainer{
  height:90% !important;
}
.dark::-webkit-scrollbar {
  width: 15px;
}

.dark::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.dark::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.dark::-webkit-scrollbar-thumb:hover {
  background: white;
}
.v-application .primary--text{
  color: #9ec9f7!important;
}
</style>